module.exports = __webpack_public_path__ + "static/media/instagram.1476d754.svg";